import { render, staticRenderFns } from "./css-footer.vue?vue&type=template&id=00656b7a&scoped=true&"
import script from "./css-footer.vue?vue&type=script&lang=js&"
export * from "./css-footer.vue?vue&type=script&lang=js&"
import style0 from "./css-footer.vue?vue&type=style&index=0&id=00656b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00656b7a",
  null
  
)

export default component.exports